<template><div><h1>VUX V2.9.2 发布日志</h1>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] 支持 prop: showCancelButton showConfirmButton #2795</li>
</ul>
<h2><a href="/zh-CN/components/datetime-view.html">DatetimeView</a></h2>
<ul><li>[fix] 修复render错误，未找到DOM元素 #2797</li>
</ul>
<h2><a href="/zh-CN/components/range.html">Range</a></h2>
<ul><li>[feature] 新增on-touchstart 和 on-touchend事件 #2804</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 修复设置最小移动距离后滑动卡住 #2773</li>
<li>[fix] 修复在循环模式下重复设置数据的错误 #2803</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[feature] button支持样式变量 #2748</li>
</ul>
<h2><a href="/zh-CN/components/x-img.html">XImg</a></h2>
<ul><li>[enhance] 支持设置separator属性 #2744</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复设置 mask 时，光标错位的问题 #2810</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.2-274.vue?414ce848